export default __webpack_public_path__ + "static/media/Image.793b8637.png";